/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type AIAgentSetupService from 'embercom/services/ai-agent-setup-service';

export default class FinAIAgentDeployChatRoute extends Route {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare aiAgentSetupService: AIAgentSetupService;

  get titleToken() {
    return this.intl.t('ai-agent.deploy.chat');
  }

  async model() {
    this.aiAgentSetupService.channelType = 'chat';
    await this.store.findAll('template');
  }
}
